@use '../../styles/theme' as *;

.threat-icon {
  @include squared-icon;

  &.scam {
    color: var(--secondary_text);
  }

  &.phishing {
    color: var(--secondary_text);
  }

  &.leaks {
    color: var(--secondary_text);
  }

  &.copyright {
    color: var(--secondary_text);
  }

  &.information {
    color: var(--secondary_text);
  }

  &.domain_squatting {
    color: var(--secondary_text);
  }
}
